import { useState } from 'react';
import GooglePlacesAutocomplete, { geocodeByLatLng, geocodeByPlaceId } from 'react-google-places-autocomplete';
import { useController } from 'react-hook-form';
const publicURL = process.env.REACT_APP_GOOGLE_MAPS_API;

interface GoogleAutocompleteControlledProps {
  region?: { region: string };
  selectProps?: any;
  addresFormField?: { name: string; rules?: any };
  localityFormField?: { name: string; rules?: any };
  regionFormField?: { name: string; rules?: any };
  extendedAddresFormField?: { name: string; rules?: any };
  countryFormField?: { name: string; rules?: any };
  postalCodeFormField?: { name: string; rules?: any };
  streetNumberFormField?: { name: string; rules?: any };
}

const getNumberRegex = /\d+/g;

function GoogleAutocompleteControlled({
  region,
  selectProps,
  addresFormField,
  extendedAddresFormField,
  localityFormField,
  regionFormField,
  countryFormField,
  postalCodeFormField,
  streetNumberFormField
}: GoogleAutocompleteControlledProps) {
  const onAddressChange = useController({
    name: addresFormField?.name || ('addresFormFieldName' as any),
    rules: addresFormField?.rules
  }).field.onChange;

  const onExtendedAddressChange = useController({
    name: extendedAddresFormField?.name || ('extendedAddresFormFieldName' as any),
    rules: extendedAddresFormField?.rules
  }).field.onChange;

  const onLocalityChange = useController({
    name: localityFormField?.name || ('localityFormFieldName' as any),
    rules: localityFormField?.rules
  }).field.onChange;

  const onRegionChange = useController({
    name: regionFormField?.name || ('regionFormFieldName' as any),
    rules: regionFormField?.rules
  }).field.onChange;

  const onCountryNameChange = useController({
    name: countryFormField?.name || ('countryFormFieldName' as any),
    rules: countryFormField?.rules
  }).field.onChange;

  const onPostalCodeChange = useController({
    name: postalCodeFormField?.name || ('postalCodeFormFieldName' as any),
    rules: postalCodeFormField?.rules
  }).field.onChange;

  const onStreetNumberChange = useController({
    name: streetNumberFormField?.name || ('streetNumberFormFieldName' as any),
    rules: streetNumberFormField?.rules
  }).field.onChange;

  const [value, setValue] = useState<any>(null);

  async function parsePlacesAutocompleteData(placesAutocompleteData: any) {
    if (placesAutocompleteData.label !== value?.label) {
      setValue(placesAutocompleteData);
      let address = await geocodeByPlaceId(placesAutocompleteData.value.place_id);
      let postalCode: string = '';
      if (!address[0].address_components.find(addressComponent => addressComponent.types.includes('postal_code'))?.long_name) {
        let address2 = await geocodeByLatLng({ lat: address[0].geometry.location.lat(), lng: address[0].geometry.location.lng() });
        postalCode = address2[0].address_components.find(addressComponent => addressComponent.types.includes('postal_code'))?.long_name || '';
      } else {
        postalCode = address[0].address_components.find(addressComponent => addressComponent.types.includes('postal_code'))?.long_name || '';
      }
      onAddressChange(address[0].address_components.find(addressComponent => addressComponent.types.includes('route'))?.long_name);
      onExtendedAddressChange(address[0].formatted_address);
      onLocalityChange(
        address[0].address_components.find(
          addressComponent => addressComponent.types.includes('locality') || addressComponent.types.includes('postal_town')
        )?.long_name
      );
      onRegionChange(
        address[0].address_components.find(addressComponent => addressComponent.types.includes('administrative_area_level_1'))?.long_name
      );
      onPostalCodeChange(postalCode);
      onCountryNameChange(address[0].address_components.find(addressComponent => addressComponent.types.includes('country'))?.short_name);
      let numberFromLabel = getNumberRegex.exec(placesAutocompleteData.label);
      onStreetNumberChange(
        address[0].address_components.find(addressComponent => addressComponent.types.includes('street_number'))?.short_name ||
          (!!numberFromLabel && numberFromLabel[0].toString())
      );
    }
  }

  return (
    <GooglePlacesAutocomplete
      apiKey={publicURL}
      apiOptions={region}
      debounce={1000}
      selectProps={{
        value,
        onChange: parsePlacesAutocompleteData,
        ...selectProps
      }}
    />
  );
}
export default GoogleAutocompleteControlled;
